/* Direct Colors pigment collection configurator. 
   Each expanded color card offers powder-only purchasing plus the real 1, 3, 5,
   and 7 lb finished-shade SKU groups. Bag size selects the final Shopify variant.
   Grey/white cement changes the shade preview only and never changes the SKU.
   Collection chips and powder choices use distinct pigment names; dose tiles retain
   their finished-shade names.
   Dose tiles use the sampled TINT colors documented below. */
(function(){
var CDN="https://cdn.shopify.com/s/files/1/0964/4988/8621/files/",V="?v=1776519913";
var SW={"122":"122.jpg"+V,
"206":"PIG-206-CHARCOAL-PIGMENT-SWATCH.webp?v=1785362660",
"215":"PIG-215-GRAY-PIGMENT-POWDER-SWATCH.webp?v=1785363185",
"216":"DC-PIG-216-KHAKI-PIGMENT-SWATCH.webp?v=1785362450",
"217":"PIG-217-LIGHT-CHARCOAL-PIGMENT-SWATCH.webp?v=1785362828",
"224":"PIG-224-SILVER-GRAY-PIGMENT-POWDER-SWATCH.webp?v=1785363504",
"226":"DC-PIG-226-TAN-PIGMENT-POWDER-SWATCH.webp?v=1785363704",
"231":"PIG-231-EAGLE-GRAY-PIGMENT-POWDER-SWATCH.webp?v=1785363325",
"294":"DC-PIG-294-BUFF-PIGMENT-POWDER-SWATCH.webp?v=1785363872"};
function photo(c){return CDN+(SW[c]||("PIG-"+c+".webp"+V));}
var DATA=[
{"c":"101","f":"Reds","a":1,"h":"#B52C2C","s":["Evening Shadow","Merlot","Fire Brick","Turkey Red"]},
{"c":"102","f":"Grays & Blacks","a":1,"h":"#322A2A","s":["Weathered Tin","Shadow","Smokestack","Graphite"]},
{"c":"103","f":"Browns & Tans","a":1,"h":"#9B621C","s":["Reed Grass","Olive Tree","Bark","Peanut"]},
{"c":"104","f":"Browns & Tans","a":1,"h":"#B4691D","s":["Wheat Buff","Briar Buff","Cider","Mandarin"]},
{"c":"105","f":"Buff & Yellows","a":1,"h":"#DB6B0F","s":["Frontier Buff","Santa Fe Tan","Canyon Brown","Orange Lily"]},
{"c":"106","f":"Buff & Yellows","a":1,"h":"#E96E16","s":["San Juan","Uplands","Turmeric","Amber Glow"]},
{"c":"107","f":"Browns & Tans","a":1,"h":"#B76124","s":["Macadamia","Gold","Cognac","Outback"]},
{"c":"108","f":"Reds","a":1,"h":"#EC4722","s":["Sandstone","Persimmon","Yam","Autumn Maple"]},
{"c":"109","f":"Reds","a":1,"h":"#DC6018","s":["Peach Begonia","Safety Orange","Terracotta","Sugar Maple"]},
{"c":"110","f":"Buff & Yellows","a":1,"h":"#EB7A1E","s":["Maize","Gamboge","Clementine","Calamondin"]},
{"c":"111","f":"Buff & Yellows","a":1,"h":"#BB7F16","s":["Ramie","Harvest Gold","Antique Oak","Fulvous"]},
{"c":"112","f":"Reds","a":1,"h":"#C2390F","s":["Mocha","Rocky Crag","Spice","Oklahoma"]},
{"c":"113","f":"Browns & Tans","a":1,"h":"#9A561D","s":["Cafe Au Lait","Tobacco","Teff","Chestnut"]},
{"c":"114","f":"Browns & Tans","a":1,"h":"#A7610C","s":["Beige","Buckwheat","Saddle","Bourbon"]},
{"c":"115","f":"Browns & Tans","a":1,"h":"#864619","s":["Taupe","Cocoa Brown","Macchiato","Brown Leather"]},
{"c":"116","f":"Browns & Tans","a":1,"h":"#6D2C2C","s":["Milk Chocolate","Deep Bronze","Bole","Espresso"]},
{"c":"117","f":"Reds","a":1,"h":"#8A1414","s":["Desert Rouge","Earthen Red","Mars","Red Bromeliad"]},
{"c":"118","f":"Browns & Tans","a":0,"h":"#6A4716","s":["Winterfield Buff","Puma","Arabia","Sable"]},
{"c":"119","f":"Buff & Yellows","a":1,"h":"#DB9B0F","s":["Sunray","Tarnished Brass","Marigold","Mustard"]},
{"c":"120","f":"Reds","a":1,"h":"#CE5B09","s":["Dawn","Sinopia","Watermelon","Vermilion"]},
{"c":"121","f":"Reds","a":1,"h":"#D6434F","s":["Sundried Tomato","Red Dahlia","Flamingo","Lava"]},
{"c":"122","f":"Reds","a":1,"h":"#9A2828","s":["Barely Lavender","Umber","Antique Rose","Dark Coral"]},
{"c":"202","f":"Blues","a":0,"h":"#234DD7","s":["Ice Blue","Steel Blue","Slate Blue","Sapphire"]},
{"c":"203","f":"Blues","a":0,"h":"#0A1376","s":["Ocean Blue","Midnight Blue","Persian Blue","Blueberry"]},
{"c":"204","f":"Greens","a":0,"h":"#408825","s":["Sea Green","Mint Green","Forest Green","Fern"]},
{"c":"205","f":"Grays & Blacks","a":0,"h":"#E1E4EA","s":["Antique Lace","Alabaster","Ash","Cumulus"]},
{"c":"206","f":"Grays & Blacks","a":1,"n":"Charcoal"},
{"c":"215","f":"Grays & Blacks","a":1,"n":"Gray"},
{"c":"216","f":"Buff & Yellows","a":1,"n":"Khaki","h":"#DCD6C1"},
{"c":"217","f":"Grays & Blacks","a":1,"n":"Light Charcoal","h":"#4F4A4A"},
{"c":"224","f":"Grays & Blacks","a":1,"n":"Silver Gray"},
{"c":"226","f":"Browns & Tans","a":1,"n":"Tan","h":"#d2b48c"},
{"c":"231","f":"Grays & Blacks","a":1,"n":"Eagle Gray","h":"#808080"},
{"c":"294","f":"Buff & Yellows","a":1,"n":"Buff"}
];
DATA.forEach(function(d){d.p=photo(d.c);});
/* ---- 6.1 chemistry, powder. Shown in the one-line card header. Replaces the old chemOf()
   guesswork, which is deleted: these 35 values are the owner-confirmed register. ---- */
var CHEM_POWDER={"101":"Iron Oxide Blend","102":"Iron Oxide Black","103":"Iron Oxide","104":"Iron Oxide Blend","105":"Iron Oxide Blend","106":"Iron Oxide Blend","107":"Iron Oxide Blend","108":"Iron Oxide","109":"Iron Oxide Blend","110":"Iron Oxide","111":"Iron Oxide Blend","112":"Iron Oxide Blend","113":"Iron Oxide Blend","114":"Iron Oxide","115":"Iron Oxide Blend","116":"Iron Oxide Blend","117":"Iron Oxide Blend","118":"Iron Oxide Blend","119":"Synthetic Yellow Iron Oxide","120":"Iron Oxide Blend","121":"Iron Oxide Blend","122":"Proprietary Blend","202":"Ultramarine Blue","203":"Copper Phthalocyanine","204":"Chromium Oxide Green","205":"Titanium Dioxide","206":"Iron Oxide Blend","215":"Blend","216":"Blend","217":"Iron Oxide Blend","224":"Iron Oxide Blend","226":"Iron Oxide Blend","231":"Iron Oxide Blend","294":"Iron Oxide Blend"};
/* Pigment/powder names approved in powder-name-proposal-v2.csv, 2026-08-15.
   These identify the raw pigment and stay separate from the dose-result shade names. */
var POWDER_NAME={"101":"Barn Red","102":"Graphite","103":"Hickory","104":"Butterscotch","105":"Pumpkin","106":"Copper","107":"Dune","108":"Burnt Orange","109":"Clay","110":"Tangerine","111":"Honeycomb","112":"Red Rock","113":"Pecan","114":"Caramel","115":"Redwood","116":"Walnut","117":"Crimson","118":"Coffee","119":"Sunflower","120":"Scarlet","121":"Cayenne","122":"Rosewood","202":"Royal Blue","203":"Blue","204":"Green","205":"White","206":"Charcoal","215":"Gray","216":"Khaki","217":"Light Charcoal","224":"Silver Gray","226":"Tan","231":"Eagle Gray","294":"Buff"};
/* ---- 6.3 colour families. FAM_OF is applied OVER the f value already in DATA rather than
   hand-editing 35 entries, so the array above stays the untouched catalogue record and the
   family assignment stays one auditable block. Chip order is FAM_ORDER, never alphabetical. ---- */
var FAM_ORDER=["Grays & Blacks","Reds","Oranges","Browns & Tans","Buffs & Yellows","Greens","Blues"];

var FAM_OF={"101":"Reds","102":"Grays & Blacks","103":"Browns & Tans","104":"Oranges","105":"Oranges","106":"Oranges","107":"Buffs & Yellows","108":"Oranges","109":"Oranges","110":"Oranges","111":"Buffs & Yellows","112":"Reds","113":"Browns & Tans","114":"Browns & Tans","115":"Reds","116":"Reds","117":"Reds","118":"Browns & Tans","119":"Buffs & Yellows","120":"Reds","121":"Reds","122":"Reds","202":"Blues","203":"Blues","204":"Greens","205":"Grays & Blacks","206":"Grays & Blacks","215":"Grays & Blacks","216":"Buffs & Yellows","217":"Grays & Blacks","224":"Grays & Blacks","226":"Buffs & Yellows","231":"Grays & Blacks","294":"Buffs & Yellows"};
DATA.forEach(function(d){if(FAM_OF[d.c])d.f=FAM_OF[d.c];});
/* 6.4 grid order: family in FAM_ORDER sequence, then ascending numeric code inside the family.
   This is the render order for every filter state, "All" included. */
DATA.sort(function(a,b){
 var fa=FAM_ORDER.indexOf(a.f),fb=FAM_ORDER.indexOf(b.f);
 if(fa!==fb)return fa-fb;
 return parseInt(a.c,10)-parseInt(b.c,10);
});
var FAMS=["All"].concat(FAM_ORDER);
var FAM_KEY={"Grays & Blacks":"greys","Reds":"reds","Oranges":"oranges","Browns & Tans":"browns","Buffs & Yellows":"buffs","Greens":"greens","Blues":"blues"};
function familyChipContent(f){
 var key=FAM_KEY[f]||"";
 return (key?'<span class="dc-family-marker dc-family-marker--'+key+'" aria-hidden="true"><i></i><i></i></span>':'')+
  '<span class="dc-family-label">'+esc(f)+'</span><span class="dc-family-check" aria-hidden="true">&#10003;</span>';
}
/* TINT: authoritative finished-shade tile colors, keyed by pigment code.
   Source: Shade Tile inventory.csv, applied 2026-08-17.
   Each code has four entries in dose order 1/3/5/7; g = grey cement and w = white cement.
   Measurement status stays in the source inventory and is intentionally not shown to shoppers.
   Shade names remain the catalog labels used for selection and cart line-item properties.
   previewOnly marks a named specimen with no matching finished-shade Shopify SKU family. */
var TINT={"101":[{"n":"Evening Shadow","w":"#AF8579","g":"#B68170"},{"n":"Merlot","g":"#A6604D","w":"#A16356"},{"n":"Fire Brick","w":"#90473A","g":"#9A4833"},{"n":"Turkey Red","w":"#904638","g":"#8E3C2E"}],
"102":[{"n":"Weathered Tin","w":"#81817F","g":"#81796E"},{"n":"Shadow","w":"#686765","g":"#6B6358"},{"n":"Smokestack","w":"#5C5C5C","g":"#5A5550"},{"n":"Graphite","w":"#5F5F5F","g":"#403C3F"}],
"103":[{"n":"Reed Grass","w":"#7C6D4C","g":"#9B8968"},{"n":"Olive Tree","w":"#7C6D4C","g":"#8F7B54"},{"n":"Bark","w":"#736445","g":"#766342"},{"n":"Peanut","w":"#655E4C","g":"#806A3C"}],
"104":[{"n":"Wheat Buff","w":"#CFAA7D","g":"#BA986C"},{"n":"Briar Buff","w":"#D2925A","g":"#BD8B54"},{"n":"Cider","w":"#C47940","g":"#C0894F"},{"n":"Mandarin","w":"#AE6F3A","g":"#C38246"}],
"105":[{"n":"Frontier Buff","w":"#D49761","g":"#CD9C69"},{"n":"Santa Fe Tan","w":"#DB7C38","g":"#C87C3D"},{"n":"Canyon Brown","w":"#C2611D","g":"#D68038"},{"n":"Orange Lily","w":"#B4612D","g":"#CD7433"}],
"106":[{"n":"San Juan","w":"#D28C55","g":"#DEA976"},{"n":"Uplands","w":"#D17B3E","g":"#E1924C"},{"n":"Turmeric","w":"#CD600D","g":"#E68E44"},{"n":"Amber Glow","w":"#D15412","g":"#DC7F39"}],
"107":[{"n":"Macadamia","w":"#C5A171","g":"#BB9763"},{"n":"Gold","w":"#B48146","g":"#AA7738"},{"n":"Cognac","w":"#AB7639","g":"#A06D2B"},{"n":"Outback","w":"#A07140","g":"#966833"}],
"108":[{"n":"Sandstone","w":"#CEA06F","g":"#D0955E"},{"n":"Persimmon","w":"#D27B46","g":"#D07A3E"},{"n":"Yam","w":"#D76729","g":"#D65A14"},{"n":"Autumn Maple","w":"#D15C16","g":"#D04E00"}],
"109":[{"n":"Peach Begonia","w":"#D88B61","g":"#D18C64"},{"n":"Safety Orange","w":"#E06B35","g":"#DA6D38"},{"n":"Terracotta","w":"#D45D23","g":"#CE5F27"},{"n":"Sugar Maple","w":"#B94B1C","g":"#B34D20"}],
"110":[{"n":"Maize","w":"#DAA464","g":"#CAA976"},{"n":"Gamboge","w":"#E9963C","g":"#DB9B50"},{"n":"Clementine","w":"#E18425","g":"#D48A3B"},{"n":"Calamondin","w":"#D27317","g":"#C6792F"}],
"111":[{"n":"Ramie","w":"#DEB685","g":"#BA966B"},{"n":"Harvest Gold","w":"#BF9362","g":"#B68852"},{"n":"Antique Oak","w":"#CE9253","g":"#AA743B"},{"n":"Fulvous","w":"#AD7133","g":"#8A541C"}],
"112":[{"n":"Mocha","w":"#CD9670","g":"#C4946C"},{"n":"Rocky Crag","w":"#A76940","g":"#BF7946"},{"n":"Spice","w":"#B36636","g":"#BB6D37"},{"n":"Oklahoma","w":"#A55522","g":"#AD5C22"}],
"113":[{"n":"Cafe Au Lait","w":"#B89D82","g":"#A68768"},{"n":"Tobacco","w":"#966F50","g":"#9F7C5B"},{"n":"Teff","w":"#725239","g":"#603E22"},{"n":"Chestnut","w":"#5E391F","g":"#4C2607"}],
"114":[{"n":"Beige","w":"#C79C79","g":"#B2916E"},{"n":"Buckwheat","w":"#8F6752","g":"#7C5D48"},{"n":"Saddle","w":"#815A3C","g":"#6E5032"},{"n":"Bourbon","w":"#7B5639","g":"#684C2F"}],
"115":[{"n":"Taupe","w":"#A58876","g":"#A4846B"},{"n":"Cocoa Brown","w":"#79594C","g":"#966D51"},{"n":"Macchiato","w":"#6D4430","g":"#7A4C2D"},{"n":"Brown Leather","w":"#5F3825","g":"#6B3F22"}],
"116":[{"n":"Milk Chocolate","w":"#A27A69","g":"#997561"},{"n":"Deep Bronze","w":"#845A4A","g":"#A67A62"},{"n":"Bole","w":"#77513E","g":"#885C46"},{"n":"Espresso","w":"#6D4430","g":"#825A49"}],
"117":[{"n":"Desert Rouge","w":"#CF6442","g":"#C36844"},{"n":"Earthen Red","w":"#C04C29","g":"#D55927"},{"n":"Mars","w":"#B3411E","g":"#B84A1E"},{"n":"Red Bromeliad","w":"#9E3216","g":"#A33B15"}],
"118":[{"n":"Winterfield Buff","w":"#C9B495","g":"#BCA883"},{"n":"Puma","w":"#B4976F","g":"#B6A078"},{"n":"Arabia","w":"#AA895B","g":"#9D7E4A"},{"n":"Sable","w":"#917447","g":"#846936"}],
"119":[{"n":"Sunray","w":"#E4BC64","g":"#D3C090"},{"n":"Tarnished Brass","w":"#DDA120","g":"#E1BC54"},{"n":"Marigold","w":"#CA9012","g":"#DBB03B"},{"n":"Mustard","w":"#C78708","g":"#DFAF2C"}],
"120":[{"n":"Dawn","w":"#C36654","g":"#B46956"},{"n":"Sinopia","w":"#AF4937","g":"#BA5B43"},{"n":"Watermelon","w":"#B34527","g":"#A54A29"},{"n":"Vermilion","w":"#A83418","g":"#9A3A1A"}],
"121":[{"n":"Sundried Tomato","w":"#C67164","g":"#CA8473"},{"n":"Red Dahlia","w":"#B84D39","g":"#C65F49"},{"n":"Flamingo","w":"#A23F2D","g":"#C4533C"},{"n":"Lava","w":"#A5381E","g":"#C44C2E"}],
"122":[{"n":"Barely Lavender","w":"#C99F99","g":"#D3BAAD"},{"n":"Umber","w":"#B7766C","g":"#D7A99D"},{"n":"Antique Rose","w":"#A5625A","g":"#CF9385"},{"n":"Dark Coral","w":"#9D5449","g":"#CB8477"}],
"202":[{"n":"Ice Blue","w":"#7DA0D8","g":"#AABAC9"},{"n":"Steel Blue","w":"#4574DD","g":"#729FE0"},{"n":"Slate Blue","w":"#2D67E5","g":"#6099EE"},{"n":"Sapphire","w":"#1855E0","g":"#386CCC"}],
"203":[{"n":"Ocean Blue","w":"#0064C7","g":"#125CA8"},{"n":"Midnight Blue","w":"#0047B5","g":"#03489B"},{"n":"Persian Blue","w":"#003BA7","g":"#0D388B"},{"n":"Blueberry","w":"#0C338B","g":"#113070"}],
"204":[{"n":"Sea Green","w":"#A9B88D","g":"#979F7A"},{"n":"Mint Green","w":"#829872","g":"#7F9562"},{"n":"Forest Green","w":"#769458","g":"#799356"},{"n":"Fern","w":"#5E7D39","g":"#698650"}],
"205":[{"n":"Antique Lace","w":"#D0CDC2","g":"#D1CEC4","previewOnly":true},{"n":"Alabaster","w":"#D7D6CE","g":"#D8D7D1","previewOnly":true},{"n":"Ash","w":"#D2CFC6","g":"#D3D0C8"},{"n":"Cumulus","w":"#D2D1CA","g":"#D3D2CC","previewOnly":true}]};
var CEMS=["grey","white"],CODES=DATA.map(function(d){return d.c;});
var PRO_TEL="tel:+14056170717",PRO_NUM="(405) 617-0717";

/* ---- 4. Icons. Inline SVG, 20x20, stroke inherits colour from the parent. ---- */
var IP={
 cart:'<circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.55L21 8H6"/>',
 shield:'<path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M9.2 12.2l2 2 3.8-4"/>',
 phone:'<path d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 5.5 5.5L16 12l4 1.5v3a2 2 0 0 1-2.2 2A15.5 15.5 0 0 1 4 6.2 2 2 0 0 1 6.5 3z"/>',
 tag:'<path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
 bag:'<path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
 check:'<circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.6 2.6L16 9.5"/>',
 info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.8" r="0.9" fill="currentColor" stroke="none"/>',
 calc:'<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 11h2M12 11h2M16 11h.01M8 15h2M12 15h2M16 15h.01"/>',
 palette:'<path d="M12 3a9 9 0 1 0 0 18c1.2 0 2-.9 2-2 0-1.5-1-1.7-1-2.8 0-.9.7-1.7 1.7-1.7H17a4 4 0 0 0 4-4c0-4.1-4-6.5-9-6.5z"/><circle cx="8" cy="10" r="1.1" fill="currentColor" stroke="none"/><circle cx="12" cy="7.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="16" cy="10" r="1.1" fill="currentColor" stroke="none"/>',
 droplet:'<path d="M12 3.5s6 6.2 6 10a6 6 0 0 1-12 0c0-3.8 6-10 6-10z"/>',
 tile:'<rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1" fill="currentColor" stroke="none"/><circle cx="15" cy="15" r="1" fill="currentColor" stroke="none"/><circle cx="15" cy="9" r="1" fill="currentColor" stroke="none"/>'
};
function ico(n,sz){var s=sz||20;
 return '<svg viewBox="0 0 24 24" width="'+s+'" height="'+s+'" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+IP[n]+'</svg>';}

/* Commerce model, 2026-08-15.
   Powder-only SKUs live on concrete-pigment-powder and follow DC-PIG-101-1LB.
   Finished-shade SKUs live on concrete-pigment-calculator and follow
   DC-PIG-GRY-101-1-1LB, where the second number is the dose rate. Grey/white
   cement changes the visual result only. It never changes the purchased SKU.

   Shopify truncates product.variants and Product JSON at 250. The shade product
   has more than 250 variants, so Liquid emits the complete powder catalog plus
   shade-product metadata. The shade variants are loaded here through paginated,
   tokenless Storefront GraphQL before shade purchasing is enabled. */
var BAG_LBS=[1,5,10,25],DOSES=[1,3,5,7],RETIRED_CODES={"201":true};
/* Verified against Shopify 2026-08-20: the shade product ships 396 variants across
   101 colours x 4 sizes (the 203 family has no 5 lb or 25 lb), and the powder product
   ships 134 across 34 codes. No 50 lb SKU exists on either any more. BAG_LBS is now a
   seed rather than a whitelist -- addVariant appends any new size it meets instead of
   silently discarding it, so re-introducing a 50 lb bag needs no code change.
   SKU_CODE_FIX repairs SKUs whose embedded colour code contradicts the variant's own
   Color option. DC-PIG-284-25LB is titled "25 Pounds / 294" and priced $145: without
   this map the configurator files it under a phantom code 284 that no card renders,
   and 294 Buff loses its 25 lb bag entirely. Fix the SKU in Shopify and this entry
   becomes dead weight that costs nothing to leave in place. */
var SKU_CODE_FIX={"DC-PIG-284-25LB":"294"};
var PDCACHE=null,PDMETA=null,PDREAD=false;
var SHADE_STATUS="idle",SHADE_ERROR="";
var BUY_STATE={};

function emptyCode(){return {powder:[],dose:{"1":[],"3":[],"5":[],"7":[]}};}
function legacyId(id){var s=String(id||"");return s.indexOf("gid://")===0?s.split("/").pop():s;}
function cents(v){
 if(typeof v==="number")return Math.round(v);
 if(v&&typeof v.amount!=="undefined")return Math.round(parseFloat(v.amount)*100);
 return Math.round(parseFloat(v)||0);
}
function lbOf(t){var m=/([\d.]+)/.exec(String(t));return m?parseFloat(m[1]):0;}
function bagLabel(lb){return lb===1?"1 Pound":lb+" Pounds";}
function money(c){return "$"+(Number(c||0)/100).toFixed(2);}
function round1(n){return Math.round(n*10)/10;}
function sortCatalog(){
 if(!PDCACHE)return;
 Object.keys(PDCACHE).forEach(function(code){
  var c=PDCACHE[code];c.powder.sort(function(a,b){return a.lb-b.lb;});
  DOSES.forEach(function(d){c.dose[String(d)].sort(function(a,b){return a.lb-b.lb;});});
 });
}
function addVariant(row,source){
 if(!row)return false;
 var sku=String(row.sku||"").trim(),m,code,dose=null,lb;
 if(source==="powder")m=/^DC-PIG-(\d{3})-(\d+(?:\.\d+)?)LB$/i.exec(sku);
 else m=/^DC-PIG-GRY-(\d{3})-(1|3|5|7)-(\d+(?:\.\d+)?)LB$/i.exec(sku);
 if(!m)return false;
 code=SKU_CODE_FIX[sku.toUpperCase()]||m[1];
 if(RETIRED_CODES[code])return false;
 if(source==="powder")lb=parseFloat(m[2]);
 else{dose=parseInt(m[2],10);lb=parseFloat(m[3]);}
 if(!(lb>0))return false;
 if(BAG_LBS.indexOf(lb)<0){BAG_LBS.push(lb);BAG_LBS.sort(function(a,b){return a-b;});}
 var rec={
  id:legacyId(row.id),sku:sku,title:row.title||bagLabel(lb),lb:lb,t:bagLabel(lb),
  p:cents(typeof row.price!=="undefined"?row.price:row.p),
  a:typeof row.availableForSale!=="undefined"?!!row.availableForSale:!!row.available
 };
 var bucket=PDCACHE[code]||(PDCACHE[code]=emptyCode());
 var list=source==="powder"?bucket.powder:bucket.dose[String(dose)];
 for(var i=0;i<list.length;i++)if(list[i].sku===sku){list[i]=rec;return true;}
 list.push(rec);return true;
}
function pdata(){
 if(PDREAD)return PDCACHE;PDREAD=true;PDCACHE={};PDMETA={};
 var el=document.getElementById("dcPowderData");if(!el)return PDCACHE;
 var data;try{data=JSON.parse(el.textContent);}catch(e){SHADE_STATUS="error";SHADE_ERROR="Product data could not be read.";return PDCACHE;}
 PDMETA=data||{};
 var rows=data&&data.powderVariants?data.powderVariants:[];
 rows.forEach(function(r){addVariant(r,"powder");});sortCatalog();
 return PDCACHE;
}
function catalogFor(code){var pd=pdata();return pd[String(code)]||emptyCode();}
function offerRows(cat,choice){return choice==="powder"?cat.powder:(cat.dose[String(choice)]||[]);}
function rowForSize(rows,lb){for(var i=0;i<rows.length;i++)if(rows[i].lb===lb)return rows[i];return null;}
function hasPurchasable(rows){for(var i=0;i<rows.length;i++)if(rows[i].a)return true;return false;}

function loadShadeCatalog(){
 pdata();
 if(SHADE_STATUS==="ready")return Promise.resolve(PDCACHE);
 if(SHADE_STATUS==="loading")return loadShadeCatalog.promise;
 var meta=PDMETA&&PDMETA.shadeProduct;
 if(!meta||!meta.handle){SHADE_STATUS="error";SHADE_ERROR="The shade-picker product is unavailable.";return Promise.reject(new Error(SHADE_ERROR));}
 SHADE_STATUS="loading";
 var query='query DcPigmentVariants($handle:String!,$after:String){product(handle:$handle){variants(first:250,after:$after){nodes{id sku title availableForSale price{amount currencyCode}}pageInfo{hasNextPage endCursor}}}}';
 var endpoint=window.location.origin+"/api/2026-04/graphql.json";
 function page(after,rows){
  return fetch(endpoint,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},
   body:JSON.stringify({query:query,variables:{handle:meta.handle,after:after||null}})})
   .then(function(res){if(!res.ok)throw new Error("Storefront product request failed ("+res.status+").");return res.json();})
   .then(function(json){
    if(json.errors&&json.errors.length)throw new Error(json.errors[0].message||"Storefront product request failed.");
    var conn=json.data&&json.data.product&&json.data.product.variants;if(!conn)throw new Error("The shade-picker product could not be loaded.");
    rows=rows.concat(conn.nodes||[]);
    return conn.pageInfo&&conn.pageInfo.hasNextPage?page(conn.pageInfo.endCursor,rows):rows;
   });
 }
 loadShadeCatalog.promise=page(null,[]).then(function(rows){
  var expected=parseInt(meta.variantCount,10)||0;
  if(expected&&rows.length<expected)throw new Error("Only "+rows.length+" of "+expected+" shade variants were returned.");
  rows.forEach(function(r){addVariant(r,"shade");});sortCatalog();SHADE_STATUS="ready";SHADE_ERROR="";return PDCACHE;
 }).catch(function(err){SHADE_STATUS="error";SHADE_ERROR=err&&err.message?err.message:"Shade products could not be loaded.";throw err;});
 return loadShadeCatalog.promise;
}

function pick(v,allowed,dflt){return allowed.indexOf(v)>-1?v:dflt;}
var st={cem:"grey",fam:"All",open:null};
var SCROLLTO=null;
var q=new URLSearchParams(location.search);
st.cem=pick(q.get("cement"),CEMS,"grey");
st.fam=pick(q.get("family"),FAMS,"All");
st.open=pick(q.get("color"),CODES,null);
function nameOf(d){
 if(POWDER_NAME[d.c])return POWDER_NAME[d.c];
 if(d.n)return d.n;
 if(d.s)return d.s[3]||d.s[2]||d.s[1]||d.s[0]||null;
 return null;
}
function esc(s){return String(s).replace(/[&<>"']/g,function(ch){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[ch];});}
function byCode(c){for(var i=0;i<DATA.length;i++)if(DATA[i].c===c)return DATA[i];return null;}
function hexOf(d){if(!d)return "#E3E8EF";
 if(d.h)return d.h;
 var t=TINT[d.c];if(t&&t[2]&&(t[2].w||t[2].g))return t[2].w||t[2].g;
 return "#E3E8EF";}
function doseLadder(){return DOSES.slice();}
function url(){var p=new URLSearchParams();
 if(st.cem!=="grey")p.set("cement",st.cem);if(st.fam!=="All")p.set("family",st.fam);if(st.open)p.set("color",st.open);
 var qs=p.toString();history.replaceState(null,"",location.pathname+(qs?"?"+qs:""));}
function wire(){
 var fam=document.getElementById("dcFam");
 if(fam)Array.prototype.forEach.call(fam.querySelectorAll("button"),function(b){
  b.setAttribute("aria-pressed",String(b.dataset.v===st.fam));
  b.onclick=function(){st.fam=b.dataset.v;st.open=null;url();render();};});
 var sel=document.getElementById("dcFamSel");
 if(sel){sel.value=st.fam;sel.onchange=function(){st.fam=sel.value;st.open=null;url();render();};}
}

/**
 * bestMatch — pick the CHEAPEST in-stock bag combination that COVERS a need.
 * Rewritten 2026-08-20 against the live 396-variant shade catalogue.
 *
 * Objective, in strict order:
 *   1. lowest TOTAL PRICE
 *   2. fewest bags
 *   3. least overage
 *
 * The previous build ranked fewest-bags FIRST and price only as a tie-break.
 * On today's ladder ($14.95 / $29.95 / $59.00 / $145.00 — $/lb falling with
 * every size step) the two objectives happen to agree, so it returned the right
 * answer by luck rather than by rule. One promotion is enough to break it: drop
 * the 10 lb bag to $45 and it overquotes on 196 of 240 tested need values, by up
 * to $25.05 a time, because it keeps preferring one 25 lb bag over three 10s.
 * Price-first is the objective the page actually promises the customer.
 *
 * NEAR-TIE PROMOTION. If a larger total costs no more than max($1.00, 1%) extra,
 * it wins outright. A strict price rule answers a 2 lb need with 2 x 1 lb at
 * $29.90 while 1 x 5 lb is $29.95 — five cents for three extra pounds and one
 * fewer line to pick. Handing over the small bags there is worse for both sides.
 * The comparison is always against the original winner, never chained, so this
 * cannot walk the customer up the ladder a cent at a time.
 *
 * UPGRADE. Where a bigger total buys pigment at a materially better marginal
 * rate for a small, bounded amount of extra money, it is returned alongside the
 * winner as `upgrade` for the UI to offer. Bounded at 15% or $10 (whichever is
 * larger) and never more than $40, and the marginal rate must beat the winner's
 * average by 40%. On the standard ladder that fires on 46 of 240 need values —
 * e.g. 21 lb: $132.95 for 21 lb, or $145.00 for a full 25 lb bag, $12.05 for
 * 4 more pounds at $3.01/lb against an average of $6.33.
 *
 * OVERAGE RAIL. Total capped at 2x need, lifted only if nothing fits under it.
 * SCALE GUARD. Exact DP up to DP_MAX lb. Above that the bulk of the order is
 * filled with the best-$/lb bag and only a DP_TAIL-sized remainder is solved
 * exactly, so a fat-fingered project size cannot allocate a multi-million-cell
 * array and lock the tab. Typed arrays with back-pointers replace the old
 * per-cell object copying.
 * BULK. At or above BULK_LB the result carries bulk:true so the card can lead
 * with a quote rather than a retail cart holding hundreds of bags.
 *
 * sizes: [{lb:Number, price:Number(cents), available:Boolean, id:String, sku:String}]
 */
var DP_MAX=20000, DP_TAIL=2000, BULK_LB=100;
function bestMatch(needLb, sizes){
  var stock=(sizes||[]).filter(function(s){return s.available&&s.lb>0;})
                       .sort(function(a,b){return a.lb-b.lb;});
  if(!stock.length||!(needLb>0)) return {kind:'none'};
  var smallest=stock[0].lb, largest=stock[stock.length-1].lb;
  if(needLb<smallest) return {kind:'sample',smallestLb:smallest};

  /* Scale guard: pre-fill the bulk with the best $/lb bag, DP only the tail. */
  var base={}, baseLb=0, basePrice=0, baseBags=0, target=needLb, approx=false;
  if(Math.ceil(needLb)>DP_MAX){
    var cheapest=stock.slice().sort(function(a,b){return (a.price/a.lb)-(b.price/b.lb);})[0];
    var k=Math.floor((needLb-DP_TAIL)/cheapest.lb);
    if(k>0){base[cheapest.lb]=k;baseLb=k*cheapest.lb;basePrice=k*cheapest.price;baseBags=k;target=needLb-baseLb;approx=true;}
  }

  var floor=Math.ceil(target-1e-9), limit=floor+largest, INF=Infinity, i, t;
  var price=new Float64Array(limit+1), bags=new Int32Array(limit+1), pick=new Int32Array(limit+1);
  for(i=1;i<=limit;i++){price[i]=INF;pick[i]=-1;}
  pick[0]=-1;
  for(t=1;t<=limit;t++){
    for(i=0;i<stock.length;i++){
      var s=stock[i]; if(s.lb>t) continue;
      var pp=price[t-s.lb]; if(pp===INF) continue;
      var cp=pp+s.price, cb=bags[t-s.lb]+1;
      if(cp<price[t]||(cp===price[t]&&cb<bags[t])){price[t]=cp;bags[t]=cb;pick[t]=i;}
    }
  }
  function rebuild(t){
    var use={},k; for(k in base) use[k]=base[k];
    while(t>0&&pick[t]>=0){var s=stock[pick[t]];use[s.lb]=(use[s.lb]||0)+1;t-=s.lb;}
    return use;
  }
  function packs(t){
    var use=rebuild(t), byLb={}; stock.forEach(function(s){byLb[s.lb]=s;});
    return Object.keys(use).map(Number).sort(function(a,b){return b-a;})
      .filter(function(lb){return byLb[lb];})
      .map(function(lb){return {lb:lb,qty:use[lb],price:byLb[lb].price,id:byLb[lb].id,sku:byLb[lb].sku||""};});
  }
  function shape(t,extra){
    var o={picks:packs(t),totalLb:baseLb+t,totalPrice:basePrice+price[t],bags:baseBags+bags[t]};
    o.wasteLb=Math.round((o.totalLb-needLb)*100)/100;
    if(extra)for(var k in extra)o[k]=extra[k];
    return o;
  }

  /* winner: cheapest covering total inside the overage rail */
  var cap=target*2, win=-1;
  for(t=floor;t<=limit;t++){
    if(price[t]===INF||t>cap) continue;
    if(win<0||price[t]<price[win]||(price[t]===price[win]&&bags[t]<bags[win])) win=t;
  }
  if(win<0) for(t=floor;t<=limit;t++){ if(price[t]!==INF){win=t;break;} }
  if(win<0) return {kind:'none'};

  /* Near-tie promotion — measured against the original winner, never chained.
     Slack is floored at $1 and CAPPED at $5: a flat 1% reads as pocket change on
     a $30 order but is $116 on a $11,600 one, and at that size it was buying the
     extra pounds at a worse rate than the bag the customer was already holding.
     The marginal-rate test below is the real guard; the cap keeps the framing
     honest ("a rounding difference") at every order size. */
  var base0=price[win], avg0=base0/win, promo=win;
  var slack=Math.max(100,Math.min(500,base0*0.01));
  for(t=win+1;t<=limit;t++){
    if(price[t]===INF) continue;
    var d0=price[t]-base0;
    if(d0>slack||t<=promo) continue;
    if(d0>0&&d0/(t-win)>avg0) continue;
    promo=t;
  }
  win=promo;

  /* upgrade — a bounded step up that buys pigment at a materially better rate */
  var upgrade=null, bestMarg=INF, avg=price[win]/win;
  var spendCap=Math.min(4000,Math.max(1000,price[win]*0.15));
  for(t=win+1;t<=limit;t++){
    if(price[t]===INF) continue;
    var dc=price[t]-price[win], dl=t-win;
    if(dc<=0||dl<=0||dc>spendCap) continue;
    var marg=dc/dl;
    if(marg>=avg*0.60||marg>=bestMarg) continue;
    bestMarg=marg; upgrade=shape(t,{extraPrice:dc,extraLb:dl,perLb:marg});
  }

  var out=shape(win,{kind:'buy',bulk:needLb>=BULK_LB,approx:approx});
  out.upgrade=upgrade;
  return out;
}
function sizesOf(rec){return (rec||[]).map(function(r){return {lb:lbOf(r.t),price:r.p,available:!!r.a,id:r.id,sku:r.sku||""};});}

/* ---- 8.1 project-size units. Dose is ALWAYS stated per 94 lb sack; the unit only changes how
   many pounds of binder the project has. ---- */
var UNITS={
  sack94:{label:'94 lb sacks of cement',   lb:94},
  bag50: {label:'50 lb sacks of overlay',  lb:50},
  cy:    {label:'cubic yards (5 sack mix)',lb:470}
};
var UNIT_ORDER=["sack94","bag50","cy"];
/* Short label for the result sentence. The mockup's "5 94 lb sacks" double-unit phrasing is a
   bug; the sentence already says "per 94 lb sack", so the quantity takes the short form. */
var UNIT_SHORT={sack94:"sacks",bag50:"50 lb overlay sacks",cy:"cubic yards"};
var SACK=94;                       // fixed; dose is always stated per 94 lb sack

function tintEntry(d,dose){var i=DOSES.indexOf(parseInt(dose,10));return i>=0&&TINT[d.c]?TINT[d.c][i]:null;}
function shadeName(d,dose){var e=tintEntry(d,dose);return e&&e.n?e.n:(dose+" lb shade");}
function shadeHex(d,dose,base){var e=tintEntry(d,dose);if(!e)return "#E9EDF2";return base==="white"?(e.w||e.g||"#E9EDF2"):(e.g||e.w||"#E9EDF2");}
function cementName(){return st.cem==="white"?"White cement":"Gray cement";}
function defaultChoice(cat){
 if(SHADE_STATUS==="ready")for(var i=0;i<DOSES.length;i++){var d=String(DOSES[i]);if(hasPurchasable(offerRows(cat,d)))return d;}
 if(hasPurchasable(cat.powder))return "powder";
 if(SHADE_STATUS==="ready")for(var j=0;j<DOSES.length;j++){var d2=String(DOSES[j]);if(offerRows(cat,d2).length)return d2;}
 return "powder";
}
function purchaseState(d,cat){
 var ps=BUY_STATE[d.c];
 if(!ps)ps=BUY_STATE[d.c]={choice:defaultChoice(cat),size:null,qty:1,autoChoice:true};
 if(ps.autoChoice&&SHADE_STATUS==="ready")ps.choice=defaultChoice(cat);
 if(ps.choice!=="powder"&&DOSES.map(String).indexOf(String(ps.choice))<0)ps.choice=defaultChoice(cat);
 if(!offerRows(cat,String(ps.choice)).length&&ps.choice!=="powder")ps.choice=defaultChoice(cat);
 return ps;
}
function choiceHTML(d,cat,ps){
 var powderDisabled=!cat.powder.length;
 var powderName=nameOf(d)||("Code "+d.c);
 var powder='<label class="dc-product-choice dc-powder-choice'+(ps.choice==="powder"?' is-selected':'')+(powderDisabled?' is-disabled':'')+'">'+
  '<span class="dc-powder-choice-image"><img src="'+esc(d.p)+'" alt="" loading="lazy"></span>'+
  '<input type="radio" name="dc-choice-'+d.c+'" value="powder"'+(ps.choice==="powder"?' checked':'')+(powderDisabled?' disabled':'')+'>'+
  '<span class="dc-choice-copy"><strong>'+esc(powderName)+' Powder</strong><span>Raw pigment · Code '+d.c+'</span></span></label>';
 var shades=DOSES.map(function(dose){
  var rows=cat.dose[String(dose)]||[],disabled=SHADE_STATUS!=="ready"||!rows.length;
  var name=shadeName(d,dose),hx=shadeHex(d,dose,st.cem);
  var status=SHADE_STATUS==="loading"?"Loading product":(!rows.length&&SHADE_STATUS==="ready"?"Not available":(dose+" lb/sack · "+(dose*5)+" lb/CY"));
  return '<label class="dc-product-choice dc-shade-choice'+(String(ps.choice)===String(dose)?' is-selected':'')+(disabled?' is-disabled':'')+'" data-dose="'+dose+'">'+
   '<span class="dcshade-swatch" style="background-color:'+hx+'"></span>'+
   '<span class="dcshade-body"><span class="dcshade-title"><input type="radio" name="dc-choice-'+d.c+'" value="'+dose+'"'+(String(ps.choice)===String(dose)?' checked':'')+(disabled?' disabled':'')+'><strong data-shade-name>'+esc(name)+'</strong></span>'+
   '<span class="dcshade-dose" data-shade-dose>'+esc(status)+'</span></span></label>';
 }).join("");
 var loadNote="";
 if(SHADE_STATUS==="loading")loadNote='<p class="dc-catalog-note" role="status">Loading finished-shade products…</p>';
 if(SHADE_STATUS==="error")loadNote='<p class="dc-catalog-note dc-catalog-error" role="status">Finished-shade purchasing could not load. <a href="/products/concrete-pigment-calculator">Use the shade picker</a>.</p>';
 return '<div class="dc-choice-layout" role="radiogroup" aria-label="Choose what you are buying">'+
  '<div class="dc-powder-column"><p class="dc-eyebrow">Powder only</p>'+powder+'</div>'+
  '<div class="dc-or" aria-hidden="true"><span>or</span></div>'+
  '<div class="dc-shade-column"><div class="dc-shade-toolbar"><p class="dc-eyebrow">Buy by finished shade</p>'+
   '<div class="dc-base-field"><span class="dc-base-label">Concrete base</span>'+
   '<div class="dc-base-toggle" role="group" aria-label="Concrete base preview">'+CEMS.map(function(base){return '<button type="button" data-base="'+base+'" aria-pressed="'+String(st.cem===base)+'">'+(base==="grey"?"Gray cement":"White cement")+'</button>';}).join("")+'</div></div></div>'+
   '<div class="dc-shade-grid" data-shade-grid>'+shades+'</div>'+loadNote+calcBannerHTML()+'</div></div>';
}
/* Two-step configurator, 2026-08-21. The third stage is gone: the running total is
   carried by the Add to cart label, the calculator CTA sits under the shade selection
   in stage one, and the bulk CTA sits under the button in stage two. These class names
   are the ones dc-pigment-ux.css already styles - .dc-purchase-actions and
   .dc-shade-column > .dc-calc-banner had rules in the stylesheet but no markup here. */
function calcBannerHTML(){
 return '<a class="dc-calc-banner" href="#dcCalc" data-calc>'+ico("calc",22)+
  '<span class="dc-wide-copy">Not sure how much to buy? <u>Use our pigment calculator</u></span>'+
  '<span class="dc-mobile-copy"><u>Pigment calculator</u></span></a>';
}
function bulkBannerHTML(){
 return '<a class="dc-bulk-banner" href="'+PRO_TEL+'">'+ico("tag",22)+
  '<span class="dc-wide-copy">Ordering 100+ lbs? <u>Get bulk pricing</u></span>'+
  '<span class="dc-mobile-copy"><u>Bulk pricing</u></span></a>';
}
function stageHead(n,title,id){return '<div class="dc-stage-head"><span class="dc-stage-number" aria-hidden="true">'+n+'</span><h4 id="'+id+'">'+esc(title)+'</h4></div>';}
function configuratorHTML(d,cat,ps){
 return '<div class="dc-configurator">'+
  '<section class="dc-stage dc-stage-one" aria-labelledby="dc-stage-one-'+d.c+'">'+stageHead(1,"Choose what you’re buying","dc-stage-one-"+d.c)+'<div data-choice-wrap>'+choiceHTML(d,cat,ps)+'</div></section>'+
  '<section class="dc-stage dc-stage-two" aria-labelledby="dc-stage-two-'+d.c+'">'+stageHead(2,"Choose bag size and quantity","dc-stage-two-"+d.c)+
   '<div class="dc-selected-offer"><span class="dc-offer-swatch" data-offer-swatch aria-hidden="true"></span><p><strong data-offer-name></strong><span data-offer-dose></span></p></div>'+
   '<div class="dc-size-qty"><fieldset class="dc-size-field"><legend>Bag size</legend><div class="dc-size-grid" data-size-grid></div>'+
   '<div class="dc-size-mobile"><span><strong data-mobile-size-name></strong><b data-mobile-size-price></b></span><select data-size-select aria-label="Bag size"></select></div></fieldset>'+
   '<div class="dc-quantity-field"><span>Bag quantity</span><div class="dcqty"><button class="dcqm" type="button" aria-label="Decrease bag quantity">−</button><input class="dcq" type="number" value="'+ps.qty+'" min="1" max="999" inputmode="numeric" aria-label="Bag quantity"><button class="dcqp" type="button" aria-label="Increase bag quantity">+</button></div></div>'+
   '<p class="dc-coverage" data-coverage></p></div>'+
   '<div class="dc-purchase-actions">'+
    '<button class="dcatc" type="button" data-add disabled>'+ico("cart",24)+'<span data-add-label>Add to cart</span></button>'+
    bulkBannerHTML()+
   '</div><p class="dcmsg" role="status" aria-live="polite"></p></section>'+
  '<div class="dc-support-row">'+
   '<a href="/products/concrete-pigment-powder-set">'+ico("bag",20)+'<span>Order a sample first</span></a>'+
   '<a href="'+PRO_TEL+'">'+ico("phone",20)+'<span>Pro Line · '+PRO_NUM+'</span></a>'+
   (d.a?'<span class="dc-compliance">'+ico("shield",20)+'<span class="dc-compliance-long"><strong>Complies with ASTM C979, Pigments for Integrally Colored Concrete.</strong> Documentation is available on request.</span><span class="dc-compliance-short">ASTM C979 compliant</span></span>':'')+
  '</div></div>';
}
function detail(d){
 var w=document.createElement("article");w.className="det";w.setAttribute("data-code",d.c);
 var nm=nameOf(d),cat=catalogFor(d.c),ps=purchaseState(d,cat);
 w.innerHTML='<header class="dc-card-header"><img class="dc-card-thumb" src="'+d.p+'" alt="" loading="lazy">'+
  '<div class="dc-card-title"><h3>'+esc(nm||("Pigment Code "+d.c))+'</h3><p>Code '+d.c+(CHEM_POWDER[d.c]?' · '+esc(CHEM_POWDER[d.c]):'')+' Pigment</p></div>'+
  '<span class="dc-header-stock" data-stock></span><button class="close" type="button" data-close>× <span>Close</span></button></header>'+
  configuratorHTML(d,cat,ps);
 w.querySelector("[data-close]").addEventListener("click",function(){st.open=null;url();render();});
 wireConfigurator(w,d,cat,ps);
 return w;
}
function firstAvailableSize(rows){for(var i=0;i<BAG_LBS.length;i++){var r=rowForSize(rows,BAG_LBS[i]);if(r&&r.a)return r.lb;}return null;}
function normalizeSelection(ps,rows){
 var selected=rowForSize(rows,Number(ps.size));
 if(!selected||!selected.a)ps.size=firstAvailableSize(rows);
 return ps.size===null?null:rowForSize(rows,Number(ps.size));
}
function sizeOptionsHTML(d,rows,ps){
 return BAG_LBS.map(function(lb){var r=rowForSize(rows,lb),disabled=!r||!r.a;
  var detail=!r?"Not available":(r.a?money(r.p):"Sold out");
  return '<label class="dc-size-option'+(Number(ps.size)===lb?' is-selected':'')+(disabled?' is-disabled':'')+'">'+
   '<input type="radio" name="dc-size-'+d.c+'" value="'+lb+'"'+(Number(ps.size)===lb?' checked':'')+(disabled?' disabled':'')+'><span><strong>'+bagLabel(lb)+'</strong><b>'+detail+'</b></span></label>';}).join("");
}
function sizeSelectOptionsHTML(rows,ps){
 return BAG_LBS.map(function(lb){var r=rowForSize(rows,lb),disabled=!r||!r.a;
  var detail=!r?"Not available":(r.a?money(r.p):"Sold out");
  return '<option value="'+lb+'"'+(Number(ps.size)===lb?' selected':'')+(disabled?' disabled':'')+'>'+bagLabel(lb)+' · '+detail+'</option>';}).join("");
}
function coverageText(choice,row){
 if(!row)return "Select an available bag size.";
 if(choice==="powder")return row.lb+" lb of raw pigment. Use the dose required by your formula.";
 var dose=parseInt(choice,10),sacks=round1(row.lb/dose),yards=round1(row.lb/dose/5);
 return row.lb+" lb bag colors "+sacks+" "+(sacks===1?"cement sack":"cement sacks")+" ("+yards+" cu yd) at this dose.";
}
function updateShadeVisuals(w,d,ps){
 Array.prototype.forEach.call(w.querySelectorAll("[data-base]"),function(b){b.setAttribute("aria-pressed",String(b.dataset.base===st.cem));});
 Array.prototype.forEach.call(w.querySelectorAll(".dc-shade-choice"),function(card){var dose=parseInt(card.dataset.dose,10);
  var sw=card.querySelector(".dcshade-swatch"),name=card.querySelector("[data-shade-name]");
  if(sw)sw.style.backgroundColor=shadeHex(d,dose,st.cem);if(name)name.textContent=shadeName(d,dose);
  card.classList.toggle("is-selected",String(ps.choice)===String(dose));});
 var powder=w.querySelector(".dc-powder-choice");if(powder)powder.classList.toggle("is-selected",ps.choice==="powder");
}
function wireConfigurator(w,d,cat,ps){
 var sizeGrid=w.querySelector("[data-size-grid]"),sizeSelect=w.querySelector("[data-size-select]"),qty=w.querySelector(".dcq"),atc=w.querySelector("[data-add]"),msg=w.querySelector(".dcmsg");
 function quantity(){var n=parseInt(qty.value,10);if(isNaN(n)||n<1)n=1;if(n>999)n=999;qty.value=n;ps.qty=n;return n;}
 function selectedName(){return ps.choice==="powder"?((nameOf(d)||("Code "+d.c))+" Powder"):shadeName(d,parseInt(ps.choice,10));}
 function paint(clearMessage){
  var rows=offerRows(cat,String(ps.choice)),selected=normalizeSelection(ps,rows),n=quantity();
  updateShadeVisuals(w,d,ps);sizeGrid.innerHTML=sizeOptionsHTML(d,rows,ps);sizeSelect.innerHTML=sizeSelectOptionsHTML(rows,ps);
  w.querySelector("[data-mobile-size-name]").textContent=selected?bagLabel(selected.lb):"Unavailable";
  w.querySelector("[data-mobile-size-price]").textContent=selected?money(selected.p):"Select another size";
  var offerName=w.querySelector("[data-offer-name]"),offerDose=w.querySelector("[data-offer-dose]");
  var offerSwatch=w.querySelector("[data-offer-swatch]");
  if(ps.choice==="powder"){
   offerSwatch.style.backgroundColor="#fff";offerSwatch.style.backgroundImage='url("'+d.p+'")';
  }else{
   offerSwatch.style.backgroundImage="none";offerSwatch.style.backgroundColor=shadeHex(d,parseInt(ps.choice,10),st.cem);
  }
  offerName.textContent=ps.choice==="powder"?selectedName():(selectedName()+" · "+cementName());
  offerDose.textContent=ps.choice==="powder"?("Raw pigment · Code "+d.c+" · dosing is up to you"):("Dose: "+ps.choice+" lb per 94 lb cement sack");
  w.querySelector("[data-coverage]").textContent=coverageText(String(ps.choice),selected);
  /* The review list is gone; the running total rides on the button label. */
  var total=selected?selected.p*n:0;
  w.querySelector("[data-add-label]").textContent=selected?("Add to cart · "+money(total)):"Unavailable";
  atc.disabled=!selected||!selected.a;
  var stock=w.querySelector("[data-stock]");
  stock.className="dc-header-stock "+(selected&&selected.a?"is-in-stock":"is-out-of-stock");
  stock.innerHTML=selected&&selected.a?(ico("check",20)+"In stock"):("Unavailable in selected size");
  if(clearMessage){msg.textContent="";msg.className="dcmsg";}
 }
 w.addEventListener("change",function(ev){
  if(ev.target.name==="dc-choice-"+d.c){ps.choice=ev.target.value;ps.autoChoice=false;ps.size=null;paint(true);if(ps.choice!=="powder")setCalc(d.c,DOSES.indexOf(parseInt(ps.choice,10)),false);}
  if(ev.target.name==="dc-size-"+d.c){ps.size=parseFloat(ev.target.value);paint(true);}
  if(ev.target.matches("[data-size-select]")){ps.size=parseFloat(ev.target.value);paint(true);}
 });
 Array.prototype.forEach.call(w.querySelectorAll("[data-base]"),function(b){b.addEventListener("click",function(){st.cem=b.dataset.base;url();paint(true);});});
 qty.addEventListener("input",function(){paint(true);});
 w.querySelector(".dcqm").addEventListener("click",function(){qty.value=Math.max(1,quantity()-1);paint(true);});
 w.querySelector(".dcqp").addEventListener("click",function(){qty.value=Math.min(999,quantity()+1);paint(true);});
 var calc=w.querySelector("[data-calc]");if(calc)calc.addEventListener("click",function(ev){ev.preventDefault();setCalc(d.c,ps.choice==="powder"?-1:DOSES.indexOf(parseInt(ps.choice,10)),true);});
 atc.addEventListener("click",function(){
  var rows=offerRows(cat,String(ps.choice)),selected=rowForSize(rows,Number(ps.size));if(!selected||!selected.a)return;
  var props={"Purchase option":ps.choice==="powder"?(selectedName()+" · Code "+d.c):(selectedName()+" ("+d.c+"-"+ps.choice+")")};
  if(ps.choice!=="powder"){
   props["Dose rate"]=ps.choice+" lb per 94 lb cement sack ("+(parseInt(ps.choice,10)*5)+" lb per 5-sack cubic yard)";
   props["Concrete base preview"]=cementName();
  }
  atc.disabled=true;msg.textContent="Adding…";msg.className="dcmsg";
  cartAdd([{id:selected.id,quantity:quantity(),properties:props}]).then(function(o){
   if(!o.ok){msg.textContent=o.why||"Could not add to cart. Try again or use the product page.";msg.className="dcmsg bad";paint(false);return;}
   msg.innerHTML="Added to cart &#10003; <a href=\"/cart\">View cart</a>";msg.className="dcmsg ok";paint(false);
  });
 });
 paint(false);
}

/* ---- 8.5 add to cart. One /cart/add.js call carrying EVERY pick, using the same sequence
   dc-paste-buy.js uses: ask the page which sections want re-rendering, POST, re-read /cart.js,
   publish the FoxTheme cartUpdate event, then open <cart-drawer>. Feature-detected exactly as
   that file does it, so the theme's own pigment-min-qty-validator and pigment-product-guard
   observe the same cart path they already observe for paste. ---- */
function cartAdd(items){
 var sections=[];
 try{document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections",{bubbles:true,detail:{sections:sections}}));}catch(e){}
 var payload={items:items};
 if(sections.length){payload.sections=sections.join(",");payload.sections_url=window.location.pathname;}
 return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(payload)})
  .then(function(res){return res.text().then(function(tx){var dt=null;try{dt=JSON.parse(tx);}catch(e){}
   return {ok:res.ok,status:res.status,data:dt};});})
  .then(function(o){
   if(!o.ok)return {ok:false,why:(o.data&&(o.data.description||o.data.message))||("Could not add to cart (error "+o.status+").")};
   return refreshCart(o.data).then(function(){return {ok:true};});})
  .catch(function(){return {ok:false,why:"Could not add to cart. Check your connection and try again."};});
}
function refreshCart(added){
 return fetch("/cart.js",{headers:{Accept:"application/json"}})
  .then(function(res){return res.json();})
  .then(function(cart){
   if(added&&added.sections)cart.sections=added.sections;
   try{if(window.FoxTheme&&FoxTheme.pubsub&&FoxTheme.pubsub.PUB_SUB_EVENTS){
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart:cart});}}catch(e){}
   var drawer=document.querySelector("cart-drawer");
   if(drawer&&typeof drawer.show==="function"){try{drawer.show();return;}catch(e){}}
   try{document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true,detail:{open:true}}));}catch(e){}
  })
  .catch(function(){});
}

/* ---- 8. Calculator. Rendered once (init) and persists across render() because it lives
   outside #dcGrid. It inherits the customer's selection: opening a color sets its Color,
   selecting a dose tile sets its Dose, and the per-card link jumps here carrying both.
   Math: totalLb = qty * UNITS[unit].lb; pigmentLb = totalLb * (dose / 94). ---- */
function calculatorShades(){
 var out=[];
 DATA.forEach(function(d){DOSES.forEach(function(dose){var e=tintEntry(d,dose);
  if(e&&e.n&&!e.previewOnly)out.push({key:d.c+"-"+dose,code:d.c,dose:dose,name:e.n,d:d});});});
 out.sort(function(a,b){var n=a.name.localeCompare(b.name);return n||a.code.localeCompare(b.code)||a.dose-b.dose;});
 return out;
}
var CALC_SHADES=calculatorShades();
function calcShadeByKey(key){for(var i=0;i<CALC_SHADES.length;i++)if(CALC_SHADES[i].key===String(key))return CALC_SHADES[i];return null;}
function calcShadeFor(code,dose){for(var i=0;i<CALC_SHADES.length;i++){var s=CALC_SHADES[i];if(s.code===String(code)&&(dose===null||typeof dose==="undefined"||s.dose===parseInt(dose,10)))return s;}return null;}
function defaultCalcShade(code,dose){
 var requested=code===null||typeof code==="undefined"?"":String(code);
 if(requested)return calcShadeFor(requested,dose)||calcShadeFor(requested,5)||calcShadeFor(requested,null)||null;
 return calcShadeFor("102",5)||CALC_SHADES[0]||null;
}
function calcShadeOptions(selectedKey){return CALC_SHADES.map(function(s){return '<option value="'+s.key+'"'+(s.key===selectedKey?' selected':'')+'>'+esc(s.name)+' · Code '+s.code+'</option>';}).join('');}
function calcDoseAmount(dose,unit){
 if(unit==="bag50")return Math.round((dose*50/SACK)*100)/100;
 if(unit==="cy")return dose*5;
 return dose;
}
function calcDoseText(dose,unit,compact){
 var amount=calcDoseAmount(dose,unit);
 if(unit==="bag50")return amount+(compact?" lb/50 lb overlay bag":" lb per 50 lb overlay bag");
 if(unit==="cy")return amount+(compact?" lb/CY":" lb per cubic yard (5-sack mix)");
 return dose+(compact?" lb/94 lb sack":" lb per 94 lb cement sack");
}
function calcDoseOptions(code,selectedDose,unit){return DOSES.map(function(dose){var s=calcShadeFor(code,dose);if(!s)return "";return '<option value="'+dose+'"'+(dose===selectedDose?' selected':'')+'>'+calcDoseText(dose,unit,false)+'</option>';}).join('');}
function calcQtyLabel(unit){return unit==="cy"?"Number of cubic yards":(unit==="bag50"?"Number of 50 lb overlay bags":"Number of cement sacks");}
function calcFormula(a,unit,dose,need){
 if(unit==="sack94")return a+' '+(a===1?'sack':'sacks')+' × '+dose+' lb = <b>'+need+' lb pigment</b>';
 if(unit==="cy")return a+' '+(a===1?'cubic yard':'cubic yards')+' × '+(dose*5)+' lb/CY = <b>'+need+' lb pigment</b>';
 return a+' × 50 lb overlay bags × '+calcDoseAmount(dose,unit)+' lb/bag = <b>'+need+' lb pigment</b>';
}
/* Cubic-yard caveat, restored 2026-08-21.
   The yardage maths assumes a five-sack yard (470 lb cementitious), which is a
   3,000 psi mix; richer mixes carry more cement per yard and therefore need more
   pigment for the same shade. Stated where the unit is chosen rather than buried
   in the footer, and hidden for the sack and overlay units where it does not apply.
   Styled INLINE rather than through dc-pigment-ux.css deliberately. An earlier
   class-based version of this note was lost when this file was rewritten on
   2026-08-21, and a class-based version would also need the stylesheet redeployed
   to come back. Inline, the note travels with this file alone.
   Toggled with style.display rather than the hidden attribute, because an inline
   display:flex overrides [hidden]. Tokens fall back to their literal values in case
   #dcCalc is mounted outside a .dcpg-scope container. */
var CY_NOTE_STYLE='display:none;align-items:flex-start;gap:.8rem;margin:1rem 0 0;'+
 'padding:1rem 1.2rem;border:1px solid var(--bdc,#C9D2DE);'+
 'border-left:3px solid var(--nav,#092751);border-radius:var(--r,.8rem);'+
 'background:var(--info,#EFF4FB);color:var(--sub,#5A5A5A);font-size:1.25rem;line-height:1.45';
var CY_NOTE_LINK='color:var(--nav,#092751);font-weight:700;text-decoration:underline';
function calcHTML(){
 var initial=defaultCalcShade("102",5),units=UNIT_ORDER.map(function(u){return '<option value="'+u+'">'+esc(UNITS[u].label)+'</option>';}).join('');
 var key=initial?initial.key:"",code=initial?initial.code:"102",dose=initial?initial.dose:5;
 return '<div class="dc-calc-head"><span class="dc-calc-icon">'+ico("calc",30)+'</span><div><h2><span class="dc-wide-copy">How much pigment do you need?</span><span class="dc-mobile-copy">Pigment calculator</span></h2>'+
  '<p class="dcci">Choose a finished shade, confirm the inherited dose, and enter your project size.</p></div></div>'+
  '<div class="dc-calc-main"><div class="dc-calc-inputs">'+
   '<section class="dc-calc-step" aria-labelledby="dc-calc-step-1"><div class="dc-calc-step-head"><span>1</span><h3 id="dc-calc-step-1"><span class="dc-wide-copy">Choose finished shade and dose</span><span class="dc-mobile-copy">Shade and dose</span></h3></div>'+
    '<div class="dc-calc-fields dc-calc-fields-choice">'+
     '<label class="dccf"><span>Finished shade</span><span class="dcswrap"><span class="dcsw" data-sw></span><select class="dccode dcshade">'+calcShadeOptions(key)+'</select></span></label>'+
     '<label class="dccf"><span>Dose</span><select class="dcdose">'+calcDoseOptions(code,dose,"sack94")+'</select></label></div></section>'+
   '<section class="dc-calc-step dc-calc-step-two" aria-labelledby="dc-calc-step-2"><div class="dc-calc-step-head"><span>2</span><h3 id="dc-calc-step-2"><span class="dc-wide-copy">Enter project size</span><span class="dc-mobile-copy">Project size</span></h3></div>'+
    '<div class="dc-calc-fields dc-calc-fields-project">'+
     '<label class="dccf"><span data-qty-label>Number of cement sacks</span><span class="dc-calc-qty"><button type="button" data-amt-minus aria-label="Decrease project quantity">−</button><input class="dcamt" type="number" min="0.5" max="100000" step="0.5" value="5" inputmode="decimal" aria-label="Project quantity"><button type="button" data-amt-plus aria-label="Increase project quantity">+</button></span></label>'+
     '<label class="dccf"><span>Project unit / sack size</span><select class="dcunit">'+units+'</select></label></div>'+
    '<div class="dcres" data-res></div>'+
    '<p class="dccynote" data-cynote style="'+CY_NOTE_STYLE+'">'+
     '<span style="flex:0 0 auto;display:inline-flex;margin-top:.1rem;color:var(--nav,#092751)">'+ico("info",20)+'</span>'+
     '<span style="min-width:0">Cubic yards are a 5 sack mix at 3,000 psi. For other psi or mix designs '+
     '<a href="/pages/contact" style="'+CY_NOTE_LINK+'">contact us</a> for loading dosage.</span></p>'+
    '</section></div>'+
   '<aside class="dc-calc-order" data-strip aria-live="polite"></aside></div>'+
  '<div class="dc-calc-foot"><p class="dcest2">'+ico("shield",22)+'<span><span class="dc-wide-copy">Calculator gives an estimate. Final color depends on cement, sand, aggregate, water content, curing, and finish.</span><span class="dc-mobile-copy">Estimate only; final color varies by materials and finish.</span></span></p>'+
   '<p class="dchelp">'+ico("phone",22)+'<span>Need help? Call Pro Line &middot; <a href="'+PRO_TEL+'">'+PRO_NUM+'</a></span></p></div>';
}
function wireCalc(c){
 var shade=c.querySelector(".dcshade"),dose=c.querySelector(".dcdose"),amt=c.querySelector(".dcamt"),unit=c.querySelector(".dcunit"),
     res=c.querySelector("[data-res]"),strip=c.querySelector("[data-strip]"),sw=c.querySelector("[data-sw]"),
     qtyLabel=c.querySelector("[data-qty-label]"),cyNote=c.querySelector("[data-cynote]");
 function currentShade(){return calcShadeByKey(shade.value)||defaultCalcShade("102",5);}
 function syncDose(){var s=currentShade();dose.innerHTML=calcDoseOptions(s.code,s.dose,unit.value);dose.value=String(s.dose);}
 /* A project size is clamped before it reaches the solver. Nothing downstream
    should have to defend itself against a pasted phone number. */
 function projectQty(){
  var a=parseFloat(amt.value);
  if(!isFinite(a)||a<0)a=0;
  if(a>100000){a=100000;amt.value=a;}
  return a;
 }
 function calc(){
  var sh=currentShade();if(!sh)return;
  var s=sh.dose,a=projectQty(),u=unit.value;
  if(sw)sw.style.background=shadeHex(sh.d,s,st.cem);
  if(qtyLabel)qtyLabel.textContent=calcQtyLabel(u);
  if(cyNote)cyNote.style.display=(u==="cy")?"flex":"none";
  var totalLb=a*(UNITS[u]?UNITS[u].lb:0),pigmentLb=totalLb*(s/SACK),need=round1(pigmentLb);
  if(a<=0||pigmentLb<=0){res.innerHTML=ico("calc")+'<span>Enter a project size to see the pigment estimate.</span>';strip.innerHTML=orderStatusHTML(sh,"Enter a project size to see the recommended order.",u);return;}
  res.innerHTML=ico("calc",22)+'<span>'+calcFormula(a,u,s,need)+'</span>';
  strip.innerHTML=stripHTML(sh,pigmentLb,u);wireStrip(c,sh,pigmentLb,u);
 }
 shade.addEventListener("change",function(){syncDose();calc();});
 dose.addEventListener("change",function(){var sh=currentShade(),next=calcShadeFor(sh.code,parseInt(dose.value,10));if(next)shade.value=next.key;syncDose();calc();});
 amt.addEventListener("input",calc);amt.addEventListener("change",calc);
 unit.addEventListener("change",function(){syncDose();calc();});
 c.querySelector("[data-amt-minus]").addEventListener("click",function(){amt.value=Math.max(.5,(parseFloat(amt.value)||.5)-.5);calc();});
 c.querySelector("[data-amt-plus]").addEventListener("click",function(){amt.value=Math.min(100000,(parseFloat(amt.value)||0)+.5);calc();});
 syncDose();calc();
}
function orderHeadHTML(){return '<div class="dc-order-head"><span>3</span><h3><span class="dc-wide-copy">Your recommended order</span><span class="dc-mobile-copy">Recommended order</span></h3></div>';}
function orderStatusHTML(sh,message,unit){return '<div class="dc-order-card">'+orderHeadHTML()+'<div class="dc-order-need"><strong>'+esc(sh.name)+'</strong><span>Code '+sh.code+' · '+calcDoseText(sh.dose,unit,false)+'</span></div><p class="dc-order-status">'+message+'</p></div>';}
/* One bestMatch per recalculation. stripHTML used to run the solve and wireStrip
   ran the identical solve again purely to rebuild the cart payload; with the DP
   that is wasted work and, worse, two chances to disagree. The result is cached
   here and read by wireStrip, which is always called immediately afterwards with
   the same arguments. */
var LAST_MATCH=null;
function packListHTML(d,picks){
 return picks.map(function(p){return '<div class="dc-order-pack"><img src="'+d.p+'" alt="" loading="lazy"><span><b>'+p.qty+' &times; '+p.lb+' lb bag</b><small>'+esc(p.sku)+'</small></span></div>';}).join('');
}
function bagSummary(m){
 return m.picks.length===1&&m.picks[0].qty===1?('1 &times; '+m.picks[0].lb+' lb bag'):(m.bags+' bags');
}
function stripHTML(sh,pigmentLb,unit){
 LAST_MATCH=null;
 if(!sh)return "";
 var d=sh.d,doseS=sh.dose,rec=offerRows(catalogFor(sh.code),String(doseS)),need=round1(pigmentLb);
 if(SHADE_STATUS==="idle"||SHADE_STATUS==="loading")return orderStatusHTML(sh,"Loading the exact finished-shade SKUs…",unit);
 if(SHADE_STATUS==="error")return orderStatusHTML(sh,"The finished-shade catalog could not be loaded. Refresh the page to try again.",unit);
 if(!rec.length)return orderStatusHTML(sh,"This finished shade and dose combination is not available for online purchase.",unit);
 var m=bestMatch(pigmentLb,sizesOf(rec));
 if(m.kind==="sample")return orderStatusHTML(sh,'Your estimate is below the smallest stocked bag. <a href="/products/concrete-pigment-powder-set">Order a sample first</a>.',unit);
 if(m.kind!=="buy")return orderStatusHTML(sh,"Every bag size for this finished shade is currently unavailable.",unit);
 LAST_MATCH=m;
 var perBag=m.picks.length===1?money(m.picks[0].price)+' per bag':m.bags+' bags selected';
 var details='/products/concrete-pigment-calculator?variant='+encodeURIComponent(m.picks[0].id);
 /* Overage is stated rather than buried: the cheapest cover is often not the
    tightest one, and a customer who is told 25 lb arrives for a 21 lb job does
    not open a ticket about it. */
 var over=m.wasteLb>0?'<small class="dc-order-over">'+m.totalLb+' lb shipped · '+m.wasteLb+' lb spare</small>':'';
 var upsell='';
 if(m.upgrade){
  upsell='<button class="dc-order-upsell" type="button" data-cup>'+
   '<span class="dc-order-upsell-tag">Better value</span>'+
   '<span class="dc-order-upsell-copy"><b>'+m.upgrade.totalLb+' lb for '+money(m.upgrade.totalPrice)+'</b>'+
   '<small>+'+money(m.upgrade.extraPrice)+' buys '+m.upgrade.extraLb+' lb more · '+money(Math.round(m.upgrade.perLb))+'/lb against '+money(Math.round(m.totalPrice/m.totalLb))+'/lb here</small></span></button>';
 }
 var bulk='';
 if(m.bulk){
  bulk='<p class="dc-order-bulk">'+ico("tag",20)+'<span>This is a '+Math.round(m.totalLb)+' lb order. <a href="'+PRO_TEL+'">Call the Pro Line on '+PRO_NUM+'</a> for bulk pricing before you check out.</span></p>';
 }
 /* is-stacked drops the mobile card out of its two-column total|button layout.
    With a bulk notice or an upsell in the flow the button lands on its own row
    and leaves an empty cell beside it; stacked, everything runs full width. */
 return '<div class="dc-order-card'+((m.bulk||m.upgrade)?' is-stacked':'')+'">'+orderHeadHTML()+'<div class="dc-order-need"><strong>'+need+' lb pigment</strong><span>'+esc(sh.name)+' · Code '+sh.code+' · '+calcDoseText(doseS,unit,true)+'</span></div>'+
  '<div class="dc-order-packs">'+packListHTML(d,m.picks)+'<span class="dcinstk">'+ico("check",20)+'In stock and ready to ship</span></div>'+
  '<div class="dc-order-total"><span>Total</span><strong>'+money(m.totalPrice)+'</strong><small>'+perBag+'</small>'+over+'</div>'+
  bulk+upsell+
  '<button class="dcatc" type="button" data-cadd>'+ico("cart",24)+'<span class="dc-wide-copy">Add '+bagSummary(m)+' to cart</span><span class="dc-mobile-copy">Add to cart</span></button><a class="dcvpd" href="'+details+'">View selected product details</a>'+
  '<p class="dcmsg" role="status" data-cmsg></p></div>';
}
function wireStrip(c,sh,pigmentLb,unit){
 var m=LAST_MATCH;if(!m||m.kind!=="buy"||!sh)return;
 var msg=c.querySelector("[data-cmsg]");
 function bind(btn,option){
  if(!btn)return;
  btn.addEventListener("click",function(){
   var label=btn.innerHTML;btn.disabled=true;if(msg){msg.textContent="Adding…";msg.className="dcmsg";}
   var items=option.picks.map(function(p){return {id:p.id,quantity:p.qty,properties:{
    "Finished shade":sh.name+" ("+sh.code+"-"+sh.dose+")",
    "Dose rate":calcDoseText(sh.dose,unit,false),
    "Concrete base preview":cementName(),
    "Estimated for":round1(pigmentLb)+" lb of code "+sh.code}};});
   cartAdd(items).then(function(o){btn.disabled=false;btn.innerHTML=label;if(!msg)return;
    if(!o.ok){msg.textContent=o.why||"Could not add to cart.";msg.className="dcmsg bad";return;}
    msg.innerHTML="Added to cart &#10003; <a href=\"/cart\">View cart</a>";msg.className="dcmsg ok";});
  });
 }
 bind(c.querySelector("[data-cadd]"),m);
 if(m.upgrade)bind(c.querySelector("[data-cup]"),m.upgrade);
}
function setCalc(code,step,scroll){
 var c=document.getElementById("dcCalc");if(!c)return;
 var dose=step>=0?DOSES[step]:null,choice=defaultCalcShade(code,dose),sel=c.querySelector(".dcshade");
 if(sel&&choice){sel.value=choice.key;sel.dispatchEvent(new Event("change"));}
 if(scroll){c.scrollIntoView({behavior:"smooth",block:"start"});var a=c.querySelector(".dcamt");if(a)a.focus({preventScroll:true});}
}
function render(){
 var g=document.getElementById("dcGrid");if(!g)return;
 var list=DATA.filter(function(d){return st.fam==="All"||d.f===st.fam;});
 var cards=[],openDetail=null,openIndex=-1;g.innerHTML="";
 list.forEach(function(d,index){
  var nm=nameOf(d),isOpen=st.open===d.c;
  var b=document.createElement("button");
  b.className="sw";b.type="button";b.setAttribute("aria-expanded",String(isOpen));
  b.setAttribute("aria-label",(nm?nm+", ":"")+"color code "+d.c+", "+d.f+(d.a?", carries an ASTM C979 statement":""));
  b.innerHTML='<span class="chipimg"><img src="'+esc(d.p)+'" alt="'+esc((nm||d.c)+' '+d.c)+'" loading="lazy">'+
   (d.a?'<span class="astm">C979</span>':"")+'</span>'+
   '<span class="meta"><span class="nm">'+esc(nm||d.c)+'</span><span class="cd">'+d.c+'</span></span>';
  b.onclick=function(){st.open=isOpen?null:d.c;SCROLLTO=st.open;url();render();};
  g.appendChild(b);cards.push(b);
  if(isOpen){openDetail=detail(d);openIndex=index;}
 });
 /* Put the expanded configurator after the selected card's complete visual row. This
    prevents empty holes in the three-column mobile grid while preserving source order. */
 if(openDetail&&cards.length){
  var tracks=getComputedStyle(g).gridTemplateColumns.split(" ").filter(Boolean).length||1;
  var rowEnd=Math.min(cards.length-1,(Math.floor(openIndex/tracks)+1)*tracks-1);
  cards[rowEnd].insertAdjacentElement("afterend",openDetail);
 }
 if(SCROLLTO&&st.open===SCROLLTO){
  var det=g.querySelector(".det");
  if(det){var r=det.getBoundingClientRect();
   det.scrollIntoView({behavior:"smooth",block:r.height<window.innerHeight*0.75?"center":"start"});}
 }
 SCROLLTO=null;
 var c=document.getElementById("dcCount");
 if(c)c.innerHTML=st.fam==="All"?'Showing all <b>'+DATA.length+'</b> colors':'Showing <b>'+list.length+'</b> of '+DATA.length+' colors';
 wire();
}
function init(){
 pdata();
 /* 6.4 chips: All, then FAM_ORDER in that exact order. Never alphabetised, never by code. */
 var fam=document.getElementById("dcFam");
 if(fam)fam.innerHTML=FAMS.map(function(f){return '<button type="button" class="chip" data-v="'+esc(f)+'">'+familyChipContent(f)+'</button>';}).join("");
 var sel=document.getElementById("dcFamSel");
 if(sel)sel.innerHTML=FAMS.map(function(f){return '<option value="'+esc(f)+'">'+esc(f)+'</option>';}).join("");
 SCROLLTO=st.open;
 render();
 var g=document.getElementById("dcGrid");
 var c=document.getElementById("dcCalc");
 /* The preferred four-block setup supplies #dcCalc in its own Custom Liquid section.
    Keep the append fallback so older combined installs continue to work. */
 if(!c&&g){c=document.createElement("div");c.id="dcCalc";c.className="dccalc";g.parentNode.appendChild(c);}
 if(c){
  if(!c.querySelector(".dccode"))c.innerHTML=calcHTML();
  if(c.getAttribute("data-dc-wired")!=="true"){wireCalc(c);c.setAttribute("data-dc-wired","true");}
  if(st.open)setCalc(st.open,-1,false);
 }
 loadShadeCatalog().then(function(){
  SCROLLTO=st.open;
  render();
  var calc=document.getElementById("dcCalc"),shade=calc&&calc.querySelector(".dcshade");
  if(shade)shade.dispatchEvent(new Event("change"));
 }).catch(function(){
  SCROLLTO=st.open;render();
  var calc=document.getElementById("dcCalc"),shade=calc&&calc.querySelector(".dcshade");
  if(shade)shade.dispatchEvent(new Event("change"));
 });
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();